export default __webpack_public_path__ + "static/media/fire.97276d31.jpg";